import React from "react";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { Text } from "../../../themes/userq/Text/Text";
import { Button } from "../../../themes/userq/Button/Button";

export const AIFeatureBanner = ({ onGenerateSummary, loading }) => {
    return (
        <div className="ai-feature-banner">
            <div className="ai-feature-banner-content">
                <Icon
                    value="Ai"
                    size="large"
                    colorClass="white-svg"
                />
                <Text type="body-text-1" cssClasses="ai-feature-banner-text">
                    Get the most of your report by enabling our AI feature
                </Text>
            </div>
            <Button
                type="secondary"
                size="medium"
                label={loading ? "Generating..." : "Generate summary"}
                cssclass="ai-generate-summary-btn"
                state={loading ? "disabled" : "active"}
                microLoading={loading}
                onClick={onGenerateSummary || (() => {
                    console.log('Generate summary clicked');
                })}
            />
        </div>
    );
};
